import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/report/old-balances", "documento": "invoices", "acceso": "sesion", "filas": ["032"], "cita": "prod:Areas/Invoices/Controllers/ReportsController.cs:24"} satisfies RutaProd;
